// IMP-138 — 라우트 경로 SSoT.
// `/Admin/License`, `/Admin/Dashboard`, `/Home` 등 라우트 문자열이 AdminLogin.js /
// LoginPage.js / rbacGuard.js 에 산재해 있어, rename 시 한 파일만 바뀌면 회귀가
// 발생한다(PR #205 리뷰 Minor 1). 단일 상수 파일로 통합한다.
//
// 정본은 실제 라우트 정의(app.js)와 동일한 canonical case 로 둔다.
// rbacGuard 의 화이트리스트는 normalizePathname() 으로 lowercase 정규화된 pathname 과
// 비교하므로, 비교용 prefix 는 본 ROUTES 에서 .toLowerCase() 로 파생한다(대소문자 통일).
export const ROUTES = {
    ADMIN_LICENSE: '/Admin/License',
    ADMIN_DASHBOARD: '/Admin/Dashboard',
    ADMIN_LOGIN: '/Admin/Login',
    LOGIN: '/Login',
    HOME: '/Home',
    // IMP-448: 티켓 딥링크 리다이렉트(ticketRoute.js)용. 값은 app.js 의 <Route path> 선언과
    // **문자 그대로** 같아야 한다 — routes.test.js 의 드리프트 가드가 그 일치를 강제한다.
    // 경로 접두사가 필요한 쪽(ticketRoute.js)이 여기서 param 세그먼트를 떼어 파생한다.
    SERVICE_TICKET: '/Service/:ticketKey?',
    ADMIN_SERVICE_TICKET: '/Admin/AdminService/:ticketKey',
    // IMP-478 P7a: 관리자 화면의 내 계정·비밀번호 변경. 외부 딜러 허용 주소(rbacGuard)에도 들어간다.
    ADMIN_MY_INFO: '/Admin/MyInfo',
    ADMIN_UPDATE_PASSWORD: '/Admin/UpdatePassword',
};
